import { DataSourceMode, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutExtraPayCompare } from "./autogen/AutogenLayoutExtraPayCompare";
import { ExtraPayCompareItem } from "./ExtraPayCompareItem";
import { ExtraPayChangeCompareItem } from "./ExtraPayChangeCompareItem";
import { BaseCompare, TableConfig } from "./BaseCompare";

export class ExtraPayCompare extends AutogenLayoutExtraPayCompare {
    private _newOrRemovedExtraPay: any[] = [];
    private _changedExtraPay: any[] = [];
    private baseCompare = new BaseCompare();

    // Delegate properties to baseCompare
    get isOrderUpdateAllowed(): boolean { return this.baseCompare.isOrderUpdateAllowed; }
    set isOrderUpdateAllowed(value: boolean) { this.baseCompare.isOrderUpdateAllowed = value; }

    get newOrRemovedExtraPay(): any[] { return this._newOrRemovedExtraPay; }
    set newOrRemovedExtraPay(value: any[]) { this._newOrRemovedExtraPay = value; }

    get changedExtraPay(): any[] { return this._changedExtraPay; }
    set changedExtraPay(value: any[]) { this._changedExtraPay = value; }

    get isInvoice(): boolean { return this.baseCompare.isInvoice; }
    set isInvoice(value: boolean) { this.baseCompare.isInvoice = value; }

    get isCompareHistory(): boolean { return this.baseCompare.isCompareHistory; }
    set isCompareHistory(value: boolean) { this.baseCompare.isCompareHistory = value; }

    setupTableData(mode: DataSourceMode): void {
        const tableConfigs: TableConfig[] = [
            {
                table: this.tableDriverExtraPay,
                label: this.labelExtraPayAddsAndDeletes,
                data: this.newOrRemovedExtraPay
            },
            {
                table: this.tableEPChanges,
                label: this.labelChanges,
                data: this.changedExtraPay
            }
        ];

        this.baseCompare.setupTableData(tableConfigs, mode);
    }

    /** This is an event handler for the onRowDisplay event of tableDriverExtraPay. */
    tableDriverExtraPayOnRowDisplay(event: TableRowDisplayEvent): void {
        this.baseCompare.handleAddDeleteRowDisplay(
            event,
            this.newOrRemovedExtraPay,
            ExtraPayCompareItem,
            ExtraPayChangeCompareItem
        );
    }

    tableEPChangesOnRowDisplay(event: TableRowDisplayEvent): void {
        this.baseCompare.handleChangeRowDisplay(
            event,
            this.changedExtraPay,
            ExtraPayCompareItem,
            ExtraPayChangeCompareItem
        );
    }
}
